<template>
<div class="page">
  <h1>Payments</h1>
  <p>We make payouts to a Stripe account.</p><p>Stripe lets you automatically deposit into a bank account for free.</p>
  <div v-if="currentBusiness.paymentMethod">
    <p style="line-height:40px;"><span style="color:#0b0; font-size:35px;margin-right:10px;">✓</span>Your Stripe account is connected.</p>
  </div>
  <div v-else>
    <button class="btn-primary" @click="connect">Connect with Stripe</button>
  </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Payments',

    computed: {
      ...mapGetters(['currentBusiness'])
    },

    methods: {
      connect: function () {
        // TODO state object
        // in state object, hold uid, business id, csrf
        window.location = 'https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_BexzvCse0DS9y3z5RK0ev6vWPOwNnOKo&scope=read_write'
      }
    }
  }
</script>

<style scoped>
p {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Payments.vue